/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocation_Receivedtitle2Inputs */

const en_coinvestments_allocation_receivedtitle2 = /** @type {(inputs: Coinvestments_Allocation_Receivedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have received a new allocation amount`)
};

/**
* | output |
* | --- |
* | "You have received a new allocation amount" |
*
* @param {Coinvestments_Allocation_Receivedtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocation_receivedtitle2 = /** @type {((inputs?: Coinvestments_Allocation_Receivedtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocation_Receivedtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocation_receivedtitle2(inputs)
});
export { coinvestments_allocation_receivedtitle2 as "coInvestments_allocation_receivedTitle" }